import { Button } from "@ocr-monorepo/ui/components/button";
import { useRef } from "react";
type Props = {
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputRef?: React.RefObject<HTMLInputElement | null>;
  showButton?: boolean;
  label?: string;
};
export default function UploadButton({
  handleInputChange,
  inputRef,
  showButton = true,
  label = "Add Files",
}: Props) {
  const localRef = useRef<HTMLInputElement>(null);
  const fileInputRef = inputRef ?? localRef;

  const triggerFileDialog = () => {
    fileInputRef?.current?.click();
  };

  return (
    <>
      {showButton && (
        <Button
          variant="outline"
          onClick={triggerFileDialog}
          size="sm"
          className="font-mono"
        >
          {label}
        </Button>
      )}
      <input
        ref={fileInputRef}
        title="upload"
        onChange={handleInputChange}
        multiple
        type="file"
        accept="application/pdf"
        className="hidden"
      />
    </>
  );
}
